import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export var EmbProdVisibilityOption;
(function (EmbProdVisibilityOption) {
    EmbProdVisibilityOption["Visible"] = "Visible";
    EmbProdVisibilityOption["Hidden"] = "Hidden";
    EmbProdVisibilityOption["HiddenNewFront"] = "HiddenNewFront";
    EmbProdVisibilityOption["VisibleAfterApprove"] = "VisibleAfterApprove";
})(EmbProdVisibilityOption || (EmbProdVisibilityOption = {}));
export class EmbeddedProductTypeResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.name = "";
        this.externalName = "";
        this.visibility = EmbProdVisibilityOption.Visible;
    }
    pk() {
        return this.externalCode;
    }
}
EmbeddedProductTypeResource.urlRoot = apiResourceUrl("embedded-product-types");
//# sourceMappingURL=EmbeddedProductTypeResource.js.map